import { useNavigate, Outlet } from 'react-router-dom';
// store
import { useSelector } from '../../store';
// styles
import { Header, Logo, Main, Footer } from './styles';
import { PrimaryButton } from '../../styles';

// ----------------------------------------------------------------------

export default function Layout() {
  const navigate  = useNavigate();
  const loggedin = useSelector((state) => state.loggedin);

  return (
    <>
      <Header>
        <Logo />
        <PrimaryButton type='button' onClick={() => navigate(loggedin ? '/real-time' : '/login')}>로그인</PrimaryButton>
      </Header>

      <Main>
        <Outlet />
      </Main>

      <Footer>
        <div>
          <p>㈜워터아이즈</p>
          <div>
            <p>기업명 : 주식회사 워터아이즈<br />사업자등록번호 : 161-88-01734</p>
            <p>대표자 : 정연욱<br />통신판매신고번호 : 2021-세종아름-0359</p>
            <p>주소 : 세종특별자치시 어진동 670 에비뉴힐 A동 5010호</p>
          </div>
        </div>

        <div>
          <p>고객센터</p>
          <div>
            <p>문의 사항이 있으신가요?</p>
            <div>
              <div>
                <div />
                <p>연락처 : 0507-1322-7243</p>
              </div>
              <i />
              <div>
                <div />
                <p>이메일 : first@water-eyes.com</p>
              </div>
            </div>
          </div>
          
          <p>판매상품에 대한 책임</p>
          <div>
            <p>워터아이즈에서 진행되는 모든 거래에 대한 책임과 배송, 교환, 환불, 민원 등의 처리는 워터아이즈내에서 진행합니다.</p>
            <div>
              <div>
                <div />
                <p>담당자 : 정연욱</p>
              </div>
              <i />
              <div>
                <div />
                <p>연락처 : 0507-1322-7243</p>
              </div>
            </div>
          </div>
        </div>
        
        <p>©Water Eyes Corp. All Rights Reserved.</p>
      </Footer>
    </>
  );
}